import { engineAPI } from 'api/axiosClient';
import { replaceUrlParams } from 'utils/replaceUrlParams';
import { GET } from 'api/constants';

const catchError = (error, isFullError) => ({
  success: false,
  error: isFullError
    ? error?.response?.data || error?.response || error
    : error?.response?.data?.message || error?.message || error,
});

export const request = async({
  url,
  method = GET,
  data,
  params,
  search,
  isFullError,
  config = {},
}) => {
  const requestUri = replaceUrlParams(url, params, search);

  try {
    const response = await engineAPI[method](requestUri, data, config);

    return { data: response?.data || {}, success: true, error: null, status: response?.status || 200 };
  } catch (error) {
    return catchError(error, isFullError);
  }
};
